// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Lightbox-Description-module--cls1--1zk3R","cls2":"Lightbox-Description-module--cls2--3JW5P Lightbox-Description-module--cls1--1zk3R"};